import Header from "@components/Header";
import ReactMarkdown from "react-markdown";
import imprint from "./imprint.md?raw";

function ImprintPage() {
  return (
    <Header>
      <div className="markdown mx-auto max-w-3xl">
        <ReactMarkdown>{imprint}</ReactMarkdown>
      </div>
    </Header>
  );
}

export default ImprintPage;
